/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const SandboxUsageBucketWidth = {
  Onem: "1m",
  Oneh: "1h",
  Oned: "1d",
} as const;
export type SandboxUsageBucketWidth = ClosedEnum<
  typeof SandboxUsageBucketWidth
>;

/** @internal */
export const SandboxUsageBucketWidth$inboundSchema: z.ZodNativeEnum<
  typeof SandboxUsageBucketWidth
> = z.nativeEnum(SandboxUsageBucketWidth);
/** @internal */
export const SandboxUsageBucketWidth$outboundSchema: z.ZodNativeEnum<
  typeof SandboxUsageBucketWidth
> = SandboxUsageBucketWidth$inboundSchema;
